<template>
  <div id="layout" class="dashboard-container-black">


    <div class="app-header">

      <div style="float:left;height: 50px;">
        <img height="30" style="margin:8px 10px 0px 22px;cursor: pointer;" v-bind:src="logoUrl" @click="TopMenuGoIndex">
        <span id="tk" hidden>{{getStaffCode2()}}</span>
      </div>
      <div style="float:left;">
        <span style="height: 40px;line-height: 40px;display: inline-block;font-size: 20px;color:white">医院绩效考核系统</span>
      </div>

      <div style="float: left;" v-if="showTopMenu">
        <div v-for="item in menusTop" v-bind:key="item.url"
             style="float:left;margin: 0px 10px;cursor: pointer;font-size: 14px;color:#C1C6C8;"
             v-on:click="TopMenuGo(item.url,item.menuCode)">
          <span v-if="menuTopCur == item.url" style="color:#fff;">{{ replaceStr(item.name)  }}</span>
          <span v-if="menuTopCur != item.url" >{{ replaceStr(item.name)  }}</span>
        </div>
        <div style="clear:both;"></div>
      </div>


      <audio ref="audio" :src="audioSrc" loop hidden></audio>

      <div style="float: right;margin-right: 10px;height: 50px;color:#C1C6C8;">


        <span class="top-text" style="margin-right: 10px">
          <i class="el-icon-s-custom"></i>
          <span @click="dialogStaffInfoShow=true">
            {{staffDTO.loginName}}『{{staffDTO.roleName}}』
          </span>
        </span>


        <span style="position: relative;height: 50px;display: inline-block;margin-right: 10px;" @mouseleave="setMoreHidden()">

          <span class="top-text" @mouseenter="setMoreVisible()">
            <span>设置</span>
            <i class="el-icon-caret-bottom"></i>
          </span>

          <transition name="fade">
            <div class="set-dropdown" v-if="showSet">
              <div class="set-dropdown-inner">

                <div class="set-item" @click="dialogPwdShow = true">
                  <i class="el-icon-s-check"></i>
                  <span style="margin-left: 10px;">修改密码</span>
                </div>
                <div class="set-item" @click="loginOut">
                   <i class="el-icon-turn-off"></i>
                  <span style="margin-left: 10px;">退出</span>
                </div>
              </div>
            </div>
          </transition>

        </span>

      </div>

      <div style="clear: both"></div>
    </div>

    <div class="app-content" :style="contentStyleObj">
      <div class="app-nav" :style="contentStyleObj" v-if="leftMenusShow">
        <app-nav v-bind:isCollapse="isCollapse" @open-tab="openTab"></app-nav>
      </div>
      <div class="app-wrap" style="position: relative">
        <div :style="contentStyleObj2" @click="menuTag" v-if="leftMenusShow">
          <img width="10" height="40" style="margin:3px 0px;" v-bind:src="menuTagImg">
        </div>

        <Tabs :tabs="tabs" :active-tab="activeTab" @switch-tab="switchTab" @close-tab="closeTab" />

        <transition name="fade" mode="out-in">
<!--          <router-view/>-->
<!--          <router-view :key="$route.fullPath"/>-->


            <keep-alive>
              <router-view></router-view>
            </keep-alive>


        </transition>
      </div>
    </div>


    <el-dialog title="密码修改" :visible.sync="dialogPwdShow" class="dialog" width='400px' center top='30vh' :close-on-click-modal='false'>
      <el-input v-model="oldPassword" placeholder="请输入旧密码" maxlength="10" minlength="6" show-password></el-input>
      <div style="height: 10px;"></div>
      <el-input v-model="newPassword" placeholder="请输入新密码" maxlength="10" minlength="6" show-password></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogPwdShow=false">取 消</el-button>
        <el-button type="primary"  @click="editPasswordSure">提交</el-button>
      </div>
    </el-dialog>

    <el-dialog title="用户信息" :visible.sync="dialogStaffInfoShow" class="dialog" width='700px' center
               top='30vh' :close-on-click-modal='false'>

      <el-row class="row">
        <el-col :span="12" class="item">
          <div class="label">登录名：{{this.staffDTO.loginName}}</div>
        </el-col>
        <el-col :span="12" class="item">
          <div class="label">角色：{{this.staffDTO.roleName}}</div>
        </el-col>
      </el-row>

      <el-row class="row">
        <el-col :span="12" class="item">
          <div class="label">真实姓名：{{this.staffDTO.realName}}</div>
        </el-col>
        <el-col :span="12" class="item">
          <div class="label">手机：{{this.staffDTO.phone}}</div>
        </el-col>
      </el-row>

      <el-row class="row">

        <el-col :span="12" class="item">
          <div class="label">政府：
            <span v-if="this.staffDTO.governmentDTO != null">{{this.staffDTO.governmentDTO.name}}[{{this.staffDTO.zoneName}}]</span>
          </div>
        </el-col>

        <el-col :span="12" class="item" v-if="this.staffDTO.businessDTO != null">
          <div class="label">商家：{{this.staffDTO.businessDTO.userDTO.name}}
            <span v-if="this.staffDTO.businessDTO.businessType==1">[家政服务商]</span>
            <span v-if="this.staffDTO.businessDTO.businessType==2">[积分兑换商]</span>
            <span v-if="this.staffDTO.businessDTO.businessType==3">[社区食堂商]</span>
          </div>
        </el-col>

      </el-row>

    </el-dialog>

  </div>
</template>

<script>

import AppNav from './AppNav';
import Tabs from './Tabs.vue';
import {getStaffCode, removeToken,getToken,replaceStr,getToken2} from '@/utils/auth'

import menuTagImgToLeft from "../assets/menuTag.png";
import menuTagImgToRight from "../assets/menuTag2.png";
import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {govRoleName, superviseRoleName, superRoleName, logoUrl,
  visualTitle,zoneRoleName} from "@/common/const";

export default {
  name: 'IndexNew',
  components: {
    AppNav,Tabs
  },
  data(){
    return{

      tabs: [],
      activeTab: null,


      showSet:false,
      dialogPwdShow:false,
      dialogStaffInfoShow:false,

      showPhone:false,
      showPhoneOut:false,

      showVisualOut:false,
      showBellOut:false,
      showTopMenu:false,


      staffDTO:JSON.parse(getToken()),
      isCollapse:false,
      leftMenusShow:true,
      showBell:true,




      menuTagImg:menuTagImgToLeft,

      imgLrd:require("../assets/ewm/elderly.png"),
      imgSjd:require("../assets/ewm/business.png"),
      imgFwd:require("../assets/ewm/serve.png"),
      imgYhd:require("../assets/ewm/nurse.png"),
      imgSyd:require("../assets/ewm/cashier.png"),

      contentStyleObj: {
        height: '',
        flexBasis:'200px',
      },

      contentStyleObj2: {
        width:'20px',
        height:'50px',
        position: 'absolute',
        top:'',
        left:'0px',
        cursor: 'pointer'
      },

      menusTop:this.$store.state.listMenuTop,
      menuTopCur:'',
      currentInstitutionCode:'',
      currentInstitutionName:'',

      oldPassword:'',
      newPassword:'',
      getToken:getToken(),
      flag:true,
      audioSrc:require('@/assets/baojing.mp3'),
      staffCode:"",

      path: this.$websocketUrl,
      socket:"",
      audio:"",
      setTimeoutPaused:'',
      lockReconnect: false,//是否真正建立连接
      timeout: 30*1000,//30秒一次心跳
      timeoutObj: null,//心跳心跳倒计时
      serverTimeoutObj: null,//心跳倒计时
      timeoutnum: null,//断开 重连倒计时
      timeAxiosWS:null,//定时请求

      logoUrl:logoUrl,
      visualTitle:visualTitle,

      intervalId:null,

    }
  },
  created(){


    this.$store.commit('update', ['topTabs',null]);
    this.tabs = [];
    let curPath = this.$route.path;
    let curPathName = this.getCurPathName(curPath);
    this.tabs.push({ path: curPath, name: curPathName });
    this.activeTab = curPath;
    this.$router.push(curPath);




    this.leftMenusShow=true

    var getToken=JSON.parse(this.getToken)
    this.staffCode = getToken.staffCode;
    if(getToken.roleName==govRoleName){
      this.path = this.path+this.staffCode+'|'+ new Date().getTime();
      this.websocketInit();

      this.showPhoneOut = true;
      this.showBellOut = true;
      this.showVisualOut = true;

      if(window.location.host=='shop-cxky.ynnqo.com'){
        this.showPhoneOut = false;
      }

    }
    if(getToken.roleName == superviseRoleName){
      this.showVisualOut = true;
    }
    if(getToken.roleName == zoneRoleName){
      this.path = this.path+this.staffCode+'|'+ new Date().getTime();
      this.websocketInit();
      this.showVisualOut = true;
    }
    if(getToken.roleName == superRoleName){
      //this.showTopMenu = false;
    }


    let listMenuDTO = JSON.parse(window.localStorage.getItem('listMenuDTO'));
    if(listMenuDTO == null||listMenuDTO == 'null'){
      this.getListMenu();
    }
    else{

      let listMenuDTO = JSON.parse(window.localStorage.getItem('listMenuDTO'));
      this.$store.commit('update', ['listMenuDTO',listMenuDTO]);

      let listMenuTop = JSON.parse(window.localStorage.getItem('listMenuTop'));
      this.$store.commit('update', ['listMenuTop',listMenuTop]);

      let listMenuLeft = JSON.parse(window.localStorage.getItem('listMenuLeft'));
      this.$store.commit('update', ['listMenuLeft',listMenuLeft]);

      let activeMenuTop = window.localStorage.getItem('activeMenuTop');
      this.$store.commit('update', ['activeMenuTop',activeMenuTop]);
      this.menuTopCur=activeMenuTop

    }


    this.getHight();
    window.addEventListener('resize', this.getHight);


    //刷新页面恢复左侧导航到刷新前到状态
    this.isCollapse = window.localStorage.getItem("isCollapse") === 'true';
    if(this.isCollapse){
      this.contentStyleObj.flexBasis = 64 + 'px'
      this.menuTagImg = menuTagImgToRight;
    }
    else{
      this.contentStyleObj.flexBasis = 200 + 'px'
      this.menuTagImg = menuTagImgToLeft;
    }


    this.intervalId = setInterval(() => {

      let that = this;

      let tk = "";
      const hasToken = getToken2();
      if(hasToken){
        let staffDTO = JSON.parse(getToken2());
        tk = staffDTO.staffCode;
      }


      let tk2 = document.getElementById("tk").innerText;

      //console.log(tk2,tk);

      if(tk2 != tk){

        clearInterval(that.intervalId); //清除计时器
        that.intervalId = null; //设置为null

        console.log("login change");

        this.$confirm('登录已改变?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showClose:false,
          showCancelButton:false,
          closeOnClickModal:false,
          type: 'warning'
        }).then(() => {

          removeToken();
          window.localStorage.setItem('activeInstitutionCode', null);
          window.localStorage.setItem('activeStaffCode', null);
          window.localStorage.setItem('activeMenuTop', null);
          window.localStorage.setItem('listMenuDTO', null);
          window.localStorage.setItem('listMenuTop', null);
          window.localStorage.setItem('listMenuLeft', null);
          window.localStorage.setItem('isHome', null);
          this.$store.commit('update', ['loginToken',null]);
          if(this.staffDTO.roleName=="医院管理员"){
            console.log(this.socket)
            if(this.socket){
              this.destroyed()
              clearTimeout(this.timeoutObj);
              clearTimeout(this.serverTimeoutObj);
              clearTimeout(this.timeAxiosWS);
              this.lockReconnect = true;
            }
          }
          this.$router.push({ path: '/login' })


        }).catch(e=>e)


      }


    }, 100);



  },
  destroyed() {

    window.removeEventListener('resize', this.getHight)

    clearInterval(this.intervalId); //清除计时器
    this.intervalId = null; //设置为null
  },
  computed:{

  },
  watch: {
    $route(to, from) {
      //console.log("$route");

      //如果 要 to(进入) 的页面是需要 keepAlive 缓存的，把 name push 进 include数组
      //if (to.meta.keepAlive) {
        //!this.include.includes(to.name) && this.include.push(to.name);
      //}

    },

    //监听局部变量
    activeMenuTop(newValue, oldValue) {
      console.log(newValue+"--"+oldValue)
    },

    //监听全局变量
    '$store.state.listMenuTop' : function(val){
      this.menusTop = val;
    },
    '$store.state.activeMenuTop' : function(val){
      this.menuTopCur = val;
    },

  },

  methods:{

    openTab(route) {
      const existing = this.tabs.find(tab => tab.path === route.path);
      if (!existing) {
        this.tabs.push({ path: route.path, name: route.name });
      }
      this.switchTab(route.path);
    },
    switchTab(path) {
      this.activeTab = path;
      this.$router.push(path);
    },
    closeTab(path) {
      //console.log("closeTab");

      if(this.tabs.length==1){
        return;
      }

      const index = this.tabs.findIndex(tab => tab.path === path);
      if (index !== -1) {
        this.tabs.splice(index, 1);
        this.switchTab(this.tabs[0]?.path || '/');
      }


      let topTabs = this.$store.state.topTabs;
      const index2 = topTabs.findIndex(item => item === path);
      if (index2 !== -1) {
        topTabs.splice(index2, 1);
        this.$store.commit('update', ['topTabs',topTabs]);
      }


    },


    getCurPathName(curPath){
      let rv = "首页";
      let listMenuLeft = JSON.parse(window.localStorage.getItem('listMenuLeft'));
      for(let i=0;i<listMenuLeft.length;i++){
        if(listMenuLeft[i].url == curPath){
          rv = listMenuLeft[i].name;
        }
        if(listMenuLeft[i].listMenuDTO != null && listMenuLeft[i].listMenuDTO.length>0){
          for(let j=0;j<listMenuLeft[i].listMenuDTO.length;j++){
            if(listMenuLeft[i].listMenuDTO[j].url == curPath){
              rv = listMenuLeft[i].listMenuDTO[j].name;
            }
          }
        }
      }
      return rv;
    },



    getStaffCode2(){

      const hasToken = getToken()
      if(hasToken){
        let staffDTO = JSON.parse(getToken());
        return staffDTO.staffCode;
      }
      else{
        return "";
      }

    },

    replaceStr(name){
      return replaceStr(name);
    },

    goVisual(){
      var getToken=JSON.parse(this.getToken);
      let staffCode = getToken.staffCode;
      let governmentName = getToken.governmentDTO.name;
      //window.open(this.$visualUrl+"#/rd?loginName="+governmentName+"&staffCode="+staffCode, '_blank');
      window.open(this.$visualUrl+"#/rd?loginName="+governmentName+"&staffCode="+staffCode
          +"&title="+this.visualTitle, '_blank');
    },

    //设置显示
    setMoreVisible(){
      this.showSet = true;
    },
    //设置隐藏
    setMoreHidden(){
      this.showSet = false;
    },

    //手机银秋显示
    setPhoneVisible(){
      this.showPhone = true;
    },
    //手机银秋隐藏
    setPhoneHidden(){
      this.showPhone = false;
    },


    timeTransmission(){//没有用到
      var that=this;
      that.timeAxiosWS && clearTimeout(that.timeAxiosWS);
      that.timeAxiosWS = setTimeout(function () {

        that.getAxios("Staff/GetWebSocket").then(resolve=>{
          if(resolve){
            clearTimeout(that.timeAxiosWS)
            that.websocketInit();
          }else{
            that.timeTransmission();
          }
        })

      },30000);
    },

    getBell(){
      this.showBell=!this.showBell
      if(this.showBell){
        this.$message.success("已开启报警提示音")
      }else{
        this.$message.error("已关闭报警提示音")
      }
    },
    websocketInit:function(){
      if(typeof(WebSocket) === "undefined"){
        alert("您的浏览器不支持socket")
      }else{
        // 实例化socket
        this.socket = new WebSocket(this.path)
        // 监听socket连接
        this.socket.onopen = this.open
        // 监听socket错误信息
        this.socket.onerror = this.error
        // 监听socket消息
        this.socket.onmessage = this.getMessage

        this.socket.onclose=this.close
      }
    },
    open: function () {
      console.log("socket连接成功")
      //开启心跳
      this.start();
    },
    error: function () {
      console.log("连接错误")
      //重连
      if(this.$store.state.loginToken){
        this.reconnect();
      }

    },
    getMessage: function (msg) {
      console.log(msg.data)
      var data=''
      try {
        data=JSON.parse(msg.data);
      } catch(e) {
        data=false;
      }

      if(data){
        var that=this
        const h = this.$createElement;
        var title=''
        clearTimeout(that.setTimeoutPaused);
        this.playAudio(1)


        var messageList=[]

        if(data.type==12){
          title='App一键求助';

          messageList.push(h('span',null , "用户："+data.user.name),h('br', null, null))
          messageList.push(h('span',null , "手机号："+data.user.phone),h('br', null, null))
          messageList.push(h('span',null , "报警时间："+data.sendTime),h('br', null, null))
          messageList.push(h('span',null , "所在小区："+data.zoneCodePathName),h('br', null, null))
          messageList.push(h('span',null , "经纬度(住址)："+data.lon+","+data.lat),h('br', null, null))
          messageList.push(h('span',null , "家庭住址："+data.address),h('br', null, null))

        }

        this.$notify({
          title: title,
          message:  h('p', {
            style:{
              'padding':'10px 0',
              width:'100%'
            },
          }, messageList),
          type: 'warning',
          duration:0,
          customClass:'baojing',
          offset:300,
          onClose:function(){
            that.playAudio(2);
            clearTimeout(that.setTimeoutPaused);
          }
        });

      }
      this.reset();
    },
    //关闭报警声音
    clickBtn(){
      this.playAudio(2);
      clearTimeout(this.setTimeoutPaused);
    },
    playAudio(type){
      switch (type) {
        case 1://播放音频
          if(this.showBell){
            this.$refs.audio.load()
            this.$refs.audio.play()
          }
          break
        case 2://暂停音频
          this.$refs.audio.pause();
          this.$notify.close()
          break
      }
    },
    close: function () {
      console.log("socket已经关闭")
      //重连
      this.reconnect();
    },
    websocketsend(msg) {
      //向服务器发送信息
      this.socket.send(msg);
    },
    reconnect() {//重新连接
      var that = this;
      if(that.lockReconnect) {
        return;
      }
      that.lockReconnect = true;
      //没连接上会一直重连，设置延迟避免请求过多\

      that.timeoutnum && clearTimeout(that.timeoutnum);
      that.timeoutnum = setTimeout(function () {
        //新连接
        that.websocketInit();
        that.lockReconnect = false;
      },5000);
    },
    reset(){//重置心跳
      var that = this;
      //清除时间
      clearTimeout(that.timeoutObj);
      clearTimeout(that.serverTimeoutObj);
      //重启心跳
      that.start();
    },
    start(){
      //开启心跳
      var self = this;
      self.timeoutObj && clearTimeout(self.timeoutObj);
      self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj);
      self.timeoutObj = setTimeout(function(){
        //这里发送一个心跳，后端收到后，返回一个心跳消息，
        if (self.socket.readyState == 1) {//如果连接正常
          let jsonObj = {userName:self.staffCode,msg:"heartCheck"};
          self.socket.send(JSON.stringify(jsonObj));
        }else{//否则重连
          self.reconnect();
        }
        self.serverTimeoutObj = setTimeout(function() {
          //超时关闭
          self.socket.close();
        }, self.timeout);
      }, self.timeout)
    },
    destroyed () {
      // 销毁监听
      this.socket.close()
    },





    menuTag(){
      if(!this.isCollapse){
        this.isCollapse = true;
        this.contentStyleObj.flexBasis = 64 + 'px'
        this.menuTagImg = menuTagImgToRight;

        window.localStorage.setItem("isCollapse",'true');

      }else{
        this.isCollapse = false;
        this.contentStyleObj.flexBasis = 200 + 'px'
        this.menuTagImg = menuTagImgToLeft;

        window.localStorage.setItem("isCollapse",'false');

      }
    },

    getListMenu(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'Staff/StaffMenu',
        data: {
          timeStr:timeStr,
          sign:hex_md5( "timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then( (response)=> {
        if(response.data.error == 0){
          let listMenuDTO = [];
          listMenuDTO = response.data.data;


          //set listMenuDTO
          this.$store.commit('update', ['listMenuDTO',listMenuDTO]);
          window.localStorage.setItem('listMenuDTO', JSON.stringify(listMenuDTO));





          //set listMenuTop
          let listMenuDTO2 = [];
          for(var i=0;i<listMenuDTO.length;i++){
            var obj = {"name":listMenuDTO[i].name,"menuCode":listMenuDTO[i].menuCode,"url":listMenuDTO[i].url};
            listMenuDTO2.push(obj);
          }
          this.$store.commit('update', ['listMenuTop',listMenuDTO2]);
          window.localStorage.setItem('listMenuTop', JSON.stringify(listMenuDTO2));


          if(listMenuDTO.length>0){

            //set activeMenuTop
            this.$store.commit('update', ['activeMenuTop','/indexTop']);
            window.localStorage.setItem('activeMenuTop','/indexTop');

            let listMenuLeft = listMenuDTO[0].listMenuDTO;
            this.$store.commit('update', ['activeMenuTop',listMenuDTO[0].url]);
            window.localStorage.setItem('activeMenuTop',listMenuDTO[0].url);
            if(listMenuLeft[0].listMenuDTO.length==0){
              this.$router.push(listMenuLeft[0].url)
            }else{
              this.$router.push(listMenuLeft[0].listMenuDTO[0].url)
            }
            this.leftMenusShow=true

            //set listMenuLeft
            this.$store.commit('update', ['listMenuLeft',listMenuLeft]);
            window.localStorage.setItem('listMenuLeft', JSON.stringify(listMenuLeft));
          }



        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }


      }).catch(function (error) {
        console.log(error);
      });
    },

    TopMenuGo(url,menuCode){
      console.log(menuCode)
      //update activeMenuTop
      this.$store.commit('update', ['activeMenuTop',url]);
      window.localStorage.setItem('activeMenuTop', url);
      //update listMenuLeft
      let listMenuDTO = JSON.parse(window.localStorage.getItem('listMenuDTO'));
      for(var i=0;i<listMenuDTO.length;i++){
        if(listMenuDTO[i].url == url){
          let listMenuLeft = listMenuDTO[i].listMenuDTO;
          this.$store.commit('update', ['listMenuLeft',listMenuLeft]);
          window.localStorage.setItem('listMenuLeft', JSON.stringify(listMenuLeft));
          this.leftMenusShow=true
          if(listMenuLeft[0].listMenuDTO.length==0){
            this.$router.push(listMenuLeft[0].url)
          }else{
            this.$router.push(listMenuLeft[0].listMenuDTO[0].url)
          }
          return;
        }
      }

    },
    TopMenuGoIndex(){

      //this.$router.push('/home/index');

      this.openTab({name:'首页',path:'/home/index'});

    },
    getHight(){
      this.contentStyleObj.height = window.innerHeight - 50 + 'px'

      let mainHeight = window.innerHeight-212 ;
      if(mainHeight<200){
        mainHeight = 200;
      }
      this.$store.commit('update', ['tableHeight',mainHeight]);

      this.contentStyleObj2.top = (window.innerHeight - 50) / 2 - 22 +'px';

    },

    loginOut(){
      this.$confirm('是否退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        document.getElementById("tk").innerText = '';

        removeToken();
        window.localStorage.setItem('activeInstitutionCode', null);
        window.localStorage.setItem('activeStaffCode', null);
        window.localStorage.setItem('activeMenuTop', null);
        window.localStorage.setItem('listMenuDTO', null);
        window.localStorage.setItem('listMenuTop', null);
        window.localStorage.setItem('listMenuLeft', null);
        window.localStorage.setItem('isHome', null);
        this.$store.commit('update', ['loginToken',null]);
        if(this.staffDTO.roleName=="医院管理员"){
          console.log(this.socket)
          if(this.socket){
            this.destroyed()
            clearTimeout(this.timeoutObj);
            clearTimeout(this.serverTimeoutObj);
            clearTimeout(this.timeAxiosWS);
            this.lockReconnect = true;
          }
        }
        this.$router.push({ path: '/login' })
      }).catch(e=>e)
    },

    editPasswordSure(){
      this.$confirm('确定修改密码?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.updatePassword()
      }).catch(e=>e)
    },
    updatePassword(){
      if(this.newPassword.length<6){
        this.$message('新密码至少为六位')
        return;
      }
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'Staff/EditMyPassword',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          oldPassword:this.oldPassword,
          newPassword:this.newPassword
        }
      }).then( (response)=> {
        console.log(response);
        if(response.data.error == 0){
          this.$message('修改成功');
          this.batchDialog=false;

          document.getElementById("tk").innerText = '';

          removeToken();
          window.localStorage.setItem('activeInstitutionCode', null);
          window.localStorage.setItem('activeStaffCode', null);
          window.localStorage.setItem('activeMenuTop', null);
          window.localStorage.setItem('listMenuDTO', null);
          window.localStorage.setItem('listMenuTop', null);
          window.localStorage.setItem('listMenuLeft', null);
          this.$router.push({ path: '/login' })

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

    getAxios(url){
      return new Promise((resolve, reject) => {
        this.$axios({
          method: 'post',
          url: this.$shopUrl+url,
          data: {
            timeStr:timeStr,
            sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
            staffCode: getStaffCode(),
          }
        }).then((response)=> {
          if(response.data.error == 0){
            resolve(response.data.data);
          }else if(response.data.error == 1){
            this.$message.error(response.data.message)
          }
        }).catch(function (error) {
          reject(error.data)
        });
      });
    },


  },

}

</script>



<style lang="scss" scoped>
@import "../../src/css/main.css";

</style>
